<template>
  <div>
    <div class="w-full bg-gray-100 text-sm text-gray-500 p-4 mb-8 rounded">
      This banner image will appear accross the top of the course.
    </div>
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5">
      <div
        v-for="(banner, index) in gallery"
        :key="index"
        v-on:mouseover="bannerHovered(index)"
        v-on:mouseout="bannerIndex = null"
        class="sample"
      >
        <div
          class="sample h-20 cursor-pointer relative"
          :style="{
            backgroundImage: 'url(' + encodeImageURI(banner.pathLong) + ') ',
            'background-size': 'cover',
            'background-position': 'center',
          }"
          @mouseover="changeTemporaryBannerUrl(banner)"
          @mouseout="removeTemporaryBanner"
          @click="
            creatingCourse ? selectBanner(banner) : changeBannerUrl(banner)
          "
        >
          <i
            v-if="
              bannerSelected &&
              bannerSelected.pathLong &&
              bannerSelected.pathLong === banner.pathLong
            "
            class="fas fa-check-circle absolute right-1 top-1 text-primary"
            style="font-size: 16px"
          />
          <i
            v-show="index === bannerIndex"
            class="fas fa-check-circle absolute right-1 top-1 text-primary opacity-50"
            style="font-size: 16px"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { encodeImageUrl } from 'utils/encodeImage';
  import { EventBus } from 'utils/event-bus';
  import updateCourse from 'services/courses/updateCourse';

  export default {
    data() {
      return {
        bannerSelected: {
          pathLong: null,
          pathShort: null,
        },
        gallery: [],
        bannerIndex: null,
      };
    },
    props: {
      creatingCourse: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters(['getCourseDetail']),
    },
    methods: {
      encodeImageURI(image_url) {
        return encodeImageUrl(image_url);
      },
      importAllBanners(r) {
        r.keys().forEach((key) => {
          if (!r(key).includes('banner')) {
            this.gallery.push({ pathLong: r(key), pathShort: key });
          }
        });
        if (!this.creatingCourse) this.setBannerSelectedOnInit();
      },
      setBannerSelectedOnInit() {
        this.gallery.forEach((element) => {
          const nameOfbanner = element.pathShort.replace('./', '');
          const auxArray = this.getCourseDetail.banner_url.split('/');
          if (
            this.getCourseDetail &&
            this.getCourseDetail.banner_url &&
            nameOfbanner === auxArray[auxArray.length - 1]
          ) {
            this.bannerSelected = element;
          }
        });
      },
      bannerHovered(index) {
        this.bannerIndex = index;
      },
      changeBannerUrl(banner) {
        const toast = {
          type: 'Info',
          message: 'Hey! This is just a demo! Sorry!',
          time: 2000,
        };
        if (
          this.$route.params.courseID === localStorage.getItem('course_sample')
        )
          return EventBus.$emit('createToast', toast);
        const payload = {};
        const bannerPath = banner.pathShort.replace('./', '');
        payload.banner_url = `/static/banners/${bannerPath}`;
        updateCourse(this.$route.params.courseID, payload)
          .then((res) => {
            this.$store.dispatch('setCourseDetail', res.data);
            this.setBannerSelectedOnInit();
            const toast = {
              type: 'Success',
              message: 'Banner changed with success!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          })
          .catch((e) => {
            console.error(e);
            const toast = {
              type: 'Error',
              message: 'There was an error in updating banner!',
              time: 5000,
            };
            EventBus.$emit('createToast', toast);
          });
      },
      selectBanner(banner) {
        this.$emit('bannerSelected', banner);
        this.bannerSelected = banner;
      },
      changeTemporaryBannerUrl(banner) {
        EventBus.$emit('changeBannerTemporary', banner);
      },
      removeTemporaryBanner() {
        EventBus.$emit('removeTemporaryBanner');
      },
    },
    mounted() {
      this.importAllBanners(
        require.context('../../../../../../static/banners', false)
      );
      if (this.creatingCourse && this.gallery && this.gallery.length) {
        this.bannerSelected = this.gallery[3];
        this.$emit('bannerSelected', this.bannerSelected);
      } else {
        this.bannerSelected.pathLong = this.getCourseDetail.banner_url;
      }
    },
  };
</script>



// WEBPACK FOOTER //
// banners.vue?65acf95f